import BisAuthForm, { STATE_BIS_LOGIN } from 'components/BisAuthForm';
import React from 'react';
import { Card, Col, Row, Container } from 'reactstrap';
import { useLocation, Link, useHistory } from 'react-router-dom';
import BISLogoWhite from '../assets/img/logo/Business-River-Logo-White.png';
import { useCookies } from 'react-cookie';


const MaintenancePage = (props) => {
  let history = useHistory();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();
  const section = query.get('section');
  const award_id = query.get('award_id');
  const [cookies, setCookies, removeCookie] = useCookies(['currentUser', 'isLoggedIn']);
  

  const logOut = (e) => {
    removeCookie('token', { path: '/' });
    removeCookie('userDetails', { path: '/' });
    removeCookie('awardSettings', { path: '/' });
    removeCookie('isWelcome', { path: '/' });
    removeCookie('currentUser', { path: '/' });
    removeCookie('isLoggedIn', { path: '/' });
    removeCookie('userRole', { path: '/' });
    removeCookie('judge', { path: '/' });
    removeCookie('judge_id', { path: '/' });
    removeCookie('coordinator_id', { path: '/' });
    removeCookie('isAccept', { path: '/' });
    removeCookie('isProceed', { path: '/' });
    removeCookie('section', { path: '/' });
    removeCookie('award_id', { path: '/' });
    removeCookie('cookie_section', { path: '/' });
    removeCookie('cookie_award_id', { path: '/' });
    removeCookie('isSubmit', { path: '/' });
    removeCookie('awardStatus', { path: '/' });
    history.push("/entrant/login?award_id="+award_id+"&section="+section);
  }

  return (
    <>
      <div className="VEPbackground d-flex align-items-center pt-5 pb-5">
          <Container className="text-center justify-content-center">
              <Row>
                <Col lg="12">
                  <h1 className='text-white font-weight-bold'>COMING SOON!</h1>
                  <p className='text-white'>Our website is under construction.</p>
                  <button type="button" onClick={logOut} className="btn newbtntheme logout-btn no-shadow">Logout</button>
                </Col>
              </Row>
          </Container>
      </div>
    </>
  );
}

export default MaintenancePage;